const getSchoolColor = schoolWithLineNodes => school => {
  if (school.isActive) return '#05E2FC';
  if (school.isClusterAggregate) return '#007C98';
  if (school.uid === schoolWithLineNodes.uid) return '#404040';
  return '#7A96A5';
};

export default getSchoolColor;



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/getSchoolColor.js